import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Gruppo } from '../models/gruppo';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class GruppoService extends ResourcefulService<Gruppo>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Gruppo);
    }
}
